export const cssPrefixes = [
    { prop: '', css: '', fun: '' },
    { prop: 'Webkit', css: '-webkit-', fun: 'webkit' },
    { prop: 'Moz', css: '-moz-', fun: 'moz' },
    { prop: 'ms', css: '-ms-', fun: 'ms' },
    { prop: 'O', css: '-o-', fun: 'o' },
];
